<template>
  <gj-modal
    class="tool-tip-box"
    v-bind="$attrs"
    v-on="$listeners"
    size="normal"
    :loading="loading"
    :visible.sync="modalVisible">
  <template #header>
    <div v-html="title"></div>
  </template>
  <template #content>
    <div style="padding:10px 0 20px">{{ msg }}</div>
  </template>
  <template #footer>
    <gj-button @click="opt(-1)"> 取消 </gj-button>
    <gj-button plain @click="opt(false)"> 确认并保持价格 </gj-button>
    <gj-button type="primary" @click="opt(true)"> 确认并恢复基础价格 </gj-button>
  </template>
  </gj-modal>
</template>

<script>
import { modalMixIn } from "@/minxins";
import {beginResume} from "@/api/ad";
export default {
  name: "",
  props: {
    title: {
      default: "提示"
    },
    msg: {
      default: "调整后的新策略将在下一个生效时段开始生效，请确认是否需要将当前正在生效的分时预算和竞价恢复到基础预算和竞价？"
    },
    data:{
      type: Array, //
      required: true
    }
  },
  mixins: [ modalMixIn ],
  data() {
    return {
      loading: false,
    };
  },
  components: {},
  methods: {
    opt(type) {
      // type -1：取消  false不恢复   true恢复
      if(type === true){
        this.loading = true
        beginResume(this.data).then(resumeTaskId => {
          this.$emit("update", type, resumeTaskId)
          this.$gjDestroy();
        }).complete(()=>{this.loading = false})
      }else {
        this.$emit("update", type)
        this.$gjDestroy();
      }
    }
  },
  created() {},
};
</script>

<style scoped lang='scss'>
/deep/.gj-modal--normal .el-dialog {
  width: 500px !important;
}
</style>